import { combineReducers } from "redux";
import paymentCardListReducer from "./paymentCardsList";
import addNewCardReducer from "./savePaymentCard";

export default combineReducers({
  newCard: addNewCardReducer,
  paymentCardList: paymentCardListReducer,
});
